<template>
  <article class="review">
    <div class="review__header">
      <BaseTitle v-if="name" v-html="name" is-medium size="m" class="review__name" />
      <BaseTitle v-if="company" v-html="company" is-normal is-dim size="s" class="review__company" />
    </div>
    <div class="review__content">
      <BaseText v-if="story" v-html="story" size="xs" class="review__text" />
      <slot />
    </div>
<!--     <div class="review__footer">
      <BaseButton is-border text="Читать полностью" size="s" />
    </div> -->
  </article>
</template>

<script>
import BaseTitle from '@/components/BaseTitle.vue';
import BaseText from '@/components/BaseText.vue';
// import BaseButton from '@/components/BaseButton.vue';

export default {
  name: 'BaseReview',
  components: {
    BaseTitle,
    BaseText,
    // BaseButton,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    company: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
  },
  computed: {
    story() {
      if (!this.text) return '';
      return this.text.split('\n').map((text) => `<p>${text}</p>`).join('');
    },
  },
};
</script>

<style lang="stylus">
.review
  display block
  background #fff
  padding 1em
  box-shadow 0 0.25em 1em rgba(0, 0, 0, 0.07)
  border-radius 1em
  +landscape()
    padding 1.5em

  &__name
    margin-bottom 0.2em

  &__header
    padding-bottom 1em
    border-bottom 1px solid alpha($c_border, 30%)

  &__content
    margin-top 1em
  // &__header
  //   display flex
  //   align-items center
  // &__image
  //   flex 0 0 6em
  //   max-width 66px
  //   border 0
  // &__name
  //   flex-grow 1
  //   flex-basis 0
  //   max-width 100%
  //   ^[0]__image ~ &
  //     max-width calc(100% - 66px)
  //     padding-left 1em
  // &__title
  //   color #000
  // &__text
  //   color #696969
  // &__content
  //   margin-top 0.5em
</style>
